module.exports = __webpack_public_path__ + "fonts/OpenSans-Italic.b38c992c.woff";